import { axios, handleApiError } from "@features/config";

export type CancelJobRequestType = {
  reason: string;
  jobId: string;
};
export type CancelJobResponseType = {
  message: string;
  data: boolean | string;
  success: boolean;
};

export const cancelJob = async (
  payload: Partial<CancelJobRequestType>
): Promise<Partial<CancelJobResponseType>> => {
  try {
    const { jobId, reason } = payload;
    const res = await axios.post(`/job/${jobId}/cancel`, { reason });
    return { data: res?.data?.data, success: true };
  } catch (error) {
    return handleApiError(error);
  }
};

export type CancelJobDetails = {
  reason: string;
  status: string;
  createdAt: string;
  jobId: string;
  user: {
    id: string;
    name: string;
    avatar: string;
  };
  order: {
    freelancerId: string;
    jobId: string;
    paidBy: string;
  };
};

export const getCancelJobRequest = async (jobId: string): Promise<CancelJobDetails[]> => {
  const res = await axios.get(`/job/${jobId}/cancel`);
  const detachResponse = res?.data?.data;
  const formattedJobDetails: CancelJobDetails[] = detachResponse.map((data: any) => ({
    status: data.status,
    reason: data.reason,
    createdAt: data.createdAt,
    user: {
      id: data.createdBy,
      name: data.createdByUser.name,
      avatar: data.createdByUser.avatar,
    },
    order: {
      freelancerId: data.freelancerId,
      jobId: data.jobId,
      paidBy: data.paidBy,
    },
  }));

  return formattedJobDetails;
};

type ResponseCancelJobType = {
  answer: string;
  jobId: string;
};
type ResponseCancelJobDataType = {
  data: any;
  success: boolean;
};

export const responseCancelJob = async (
  payload: ResponseCancelJobType
): Promise<ResponseCancelJobDataType> => {
  const { jobId, answer } = payload;
  const res = await axios.post(`/job/${jobId}/cancel`, { response: { answer } });
  return { data: res?.data?.data, success: true };
};
